import React from "react";
import heroImage from "../../assets/bole-mafi-location1.jpg";
import styles from "./ImageSection.module.css";

function ImageSection() {
  return (
    <section className={styles.imageSection}>
      <div className={styles.container}>
        {/* The Image */}
        <img
          src={heroImage}
          alt="Dukamo Coffee Mafi Location"
          className={styles.shopImage}
        />

        {/* The Caption (KEPT as requested) */}
        <p className={styles.imageCaption}>Dukamo Coffee Mafi Location</p>
      </div>
    </section>
  );
}

export default ImageSection;
